import React from 'react';

const Header = ({ darkMode, setDarkMode, isMobile, toggleSidebar, appVersion }) => {
  return (
    <div className={`fixed top-0 left-0 right-0 ${darkMode ? 'bg-gray-900' : 'bg-white'} shadow-md z-50 py-3 px-6`}>
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <div className="flex items-center gap-2">
          {isMobile && (
            <button 
              onClick={toggleSidebar}
              className="mr-4 p-2"
            >
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className="h-6 w-6" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M4 6h16M4 12h16M4 18h16" 
                />
              </svg>
            </button>
          )}
          <div className="flex items-center">
            {/* Temaya göre farklı logo dosyası kullan - Dosya adı büyük harfle başlıyor Mext_footer_logo.svg */}
            <img 
              src={darkMode 
                ? "/assets/images/Mext_footer_logo.svg" 
                : "/assets/images/mext_footer_logo_dark.svg"} 
              alt="Mext Logo" 
              className="h-6 w-auto" 
            />
            <div className={`flex items-center justify-center mx-2 h-8 w-8 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
              <span className="text-lg font-bold">&</span>
            </div>
            <img 
              src="/assets/images/escon_logo.png" 
              alt="Escon Logo" 
              className="h-8 w-auto" 
            />
          </div>
          <div className="ml-3 flex items-center">
            <span className={`font-bold text-lg ${darkMode ? 'text-white' : 'text-gray-800'}`}>
              Endüstriyel Isı Pompası
            </span>
            {appVersion && (
              <span className={`ml-2 text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                v{appVersion}
              </span>
            )}
          </div>
        </div>
        <div className="flex items-center gap-4">
          <button 
            onClick={() => setDarkMode(!darkMode)} 
            className={`px-3 py-2 rounded-md ${
              darkMode ? 'bg-gray-700 text-yellow-300' : 'bg-gray-100 text-gray-600'
            }`}
          >
            {darkMode ? '🌙 Dark' : '☀️ Light'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Header;